/**
 * SecureEmbed Energy Portal - Upgrade CTA Component
 */

import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { getTierLabel } from '../constants/tiers';

interface UpgradeCTAProps {
  targetTier: number;
  inline?: boolean;
}

const UpgradeCTA: React.FC<UpgradeCTAProps> = ({ targetTier, inline }) => {
  if (inline) {
    return (
      <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#2B064F] to-[#4A0E78] text-white rounded-lg font-medium hover:opacity-90 transition-opacity shadow-lg">
        <ArrowUpRight className="w-4 h-4" />
        Upgrade to {getTierLabel(targetTier)}
      </button>
    );
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center z-10">
      <div className="tier-blur-overlay" />
      <button className="relative z-20 flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#2B064F] to-[#4A0E78] text-white rounded-xl font-semibold hover:opacity-90 transition-opacity shadow-2xl">
        <ArrowUpRight className="w-5 h-5" />
        Upgrade to {getTierLabel(targetTier)}
      </button>
    </div>
  );
};

export default UpgradeCTA;
